import { Controller } from "@hotwired/stimulus";
export default class extends Controller {
  connect() {
    this.load();
  }

  load() {
    fetch(this.data.get("url"))
      .then(response => {
        if (!response.ok) {
          throw response;
        }
        return response.text();
      })
      .then(html => {
        this.element.innerHTML = html;
        if ($("#recent-invoices-chart-container").length) {
          applyBrandStyles();
          initializeTooltips();
          recentInvoicesChart();
        }
      })
      .catch(err => {
        showCardLoadError(this.element, err);
      });
  }
}
